export default [
  { label: "admin", value: "admin" },
  { label: "normal", value: "normal" }
];
